import { Link } from 'react-router-dom';
import { ChevronLeft, Heart } from 'lucide-react';

const LOGO_URL = '/logo.webp';

export const WorkoutDetailHeader = ({ isFavorite, onToggleFavorite }) => (
  <header className="sticky top-0 z-50 glass border-b border-border">
    <div className="container mx-auto px-6 py-4 flex items-center justify-between">
      <Link to="/workouts" className="flex items-center gap-2 text-white hover:text-primary transition-colors">
        <ChevronLeft className="h-5 w-5" />
        <span className="font-medium">Back</span>
      </Link>
      <img src={LOGO_URL} alt="Ascend & Surpass" className="h-10 w-10" />
      <button
        onClick={onToggleFavorite}
        className="h-10 w-10 flex items-center justify-center hover:bg-white/10 transition-colors rounded"
        data-testid="favorite-btn"
      >
        <Heart className={`h-6 w-6 ${isFavorite ? 'text-primary fill-primary' : 'text-white'}`} />
      </button>
    </div>
  </header>
);
